import React, { useCallback } from 'react';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { UserDashboardPage } from './UserDashboardPage';
import { UserDashboardHeader } from './UserDashboardHeader';
import { DashboardPageStateProvider } from '../../hooks/useDashboardPageState';
import { PhaseDrawer } from './PhaseDrawer';

export const UserDetails = () => {
  const { userId } = useParams();
  const navigate = useNavigate();

  const handlePhaseLink = useCallback(
    (phase) => {
      navigate(`/user-details/${userId}/${phase}`);
    },
    [navigate, userId]
  );

  return (
    <DashboardPageStateProvider patientId={userId}>
      <Routes>
        <Route
          path={'/'}
          element={
            <UserDashboardPage
              header={
                <UserDashboardHeader prevRoute={`/hc-dashboard/${userId}`} />
              }
              onPhaseDetailsClick={handlePhaseLink}
              onPhaseLinkClick={handlePhaseLink}
              readonly={true}
            />
          }
        >
          <Route
            path={':phase'}
            element={
              <PhaseDrawer
                onClose={() => navigate(`/user-details/${userId}`)}
              />
            }
          ></Route>
        </Route>
      </Routes>
    </DashboardPageStateProvider>
  );
};
